__turbopack_context__.v({
  "className": "DpHkHq_className",
  "variable": "DpHkHq_variable",
});
